import Placeholder from '@/components/core/Placeholder';
import SectionMegaMenu from '@/components/elements/SectionMegaMenu';
import ServiceMegaMenu from '@/components/elements/ServiceMegaMenu';
import StaffMegaMenu from '@/components/elements/StaffMegaMenu';

import dropdownListPrimary from './listPrimary';
import dropdownListSecondary from './listSecondary';

const Dropdowns = {
  dropdownListPrimary,
  dropdownListSecondary,
  serviceMegaMenu: ServiceMegaMenu,
  sectionMegaMenu: SectionMegaMenu,
  staffMegaMenu: StaffMegaMenu,
};

const DynamicDropdowns = ({ dropdown }) => {
  if (typeof Dropdowns[dropdown.component] !== 'undefined') {
    const Component = Dropdowns[dropdown.component];
    return <Component dropdown={dropdown} />;
  }
  return <Placeholder componentName={dropdown.component} />;
};

export default DynamicDropdowns;
